export const GET_FINANCIAL_ACCOUNT = "GET_FINANCIAL_ACCOUNT";

export const CLEAR_SETTING = "CLEAR_SETTING";

export const GET_PROFILE_SETTING = "GET_PROFILE_SETTING";
export const UPDATE_PROFILE_SETTING = "UPDATE_PROFILE_SETTING";

export const GET_TRANSACTION_LIST = "GET_TRANSACTION_LIST";
export const CLEAR_TRANSACTION_LIST = "CLEAR_TRANSACTION_LIST";
export const SEARCH_TRANSACTION_LIST = "SEARCH_TRANSACTION_LIST";

export const GET_REDEMPTION_LIST = "GET_REDEMPTION_LIST";
export const CLEAR_REDEMPTION_LIST = "CLEAR_REDEMPTION_LIST";

export const GET_CUSTOMER_LIST = "GET_CUSTOMER_LIST";
export const CLEAR_CUSTOMER_LIST = "CLEAR_CUSTOMER_LIST";
export const SEARCH_CUSTOMER_LIST = "SEARCH_CUSTOMER_LIST";

export const GET_CAMPAIGNS = "GET_CAMPAIGNS";
export const GET_CAMPAIGN = "GET_CAMPAIGN";
export const GET_SAMPLE_CAMPAIGNS = "GET_SAMPLE_CAMPAIGNS";
export const CLEAR_CAMPAIGNS = "CLEAR_CAMPAIGNS";
export const CREATE_SAMPLE_CAMPAIGNS = "CREATE_SAMPLE_CAMPAIGNS";
export const UPDATE_SAMPLE_CAMPAIGN = "UPDATE_SAMPLE_CAMPAIGN";

export const SHOW_SITE_LOADER = "SHOW_SITE_LOADER";
export const HIDE_SITE_LOADER = "HIDE_SITE_LOADER";

export const AUTH_ERROR = "AUTH_ERROR";
export const LOGOUT = "LOGOUT";
export const AUTH = "AUTH";

export const GET_BUSINESS_GOAL = "GET_BUSINESS_GOAL";
export const CLEAR_BUSINESS_GOAL = "CLEAR_BUSINESS_GOAL";

export const GET_UPLOAD_FILE_DETAILS = "GET_UPLOAD_FILE_DETAILS";
export const CLEAR_UPLOAD_FILE_DETAILS = "CLEAR_UPLOAD_FILE_DETAILS";

export const VOUCHER_TEMPLATE_DETAIL = "VOUCHER_TEMPLATE_DETAIL";
export const CLEAR_VOUCHER_TEMPLATE = "CLEAR_VOUCHER_TEMPLATE";

export const LOAD_Fullfillment_TOKEN = "LOAD_Fullfillment_TOKEN";

